import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import PageHero from "../../components/pageHero/PageHero";
import ExperienceTimeline from "../../containers/experienceTimeline/ExperienceTimeline";
import "./Experience.css";
import { experience } from "../../portfolio.js";

class Experience extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-main">
        <Header theme={theme} />
        <PageHero
          kicker={experience.subtitle}
          title={experience.title}
          description={experience.description}
        />
        <div className="page-wrap">
          <ExperienceTimeline sections={experience.sections} />
        </div>
        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Experience;
